/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Uslernfoerderung4Inputs */

const de__field_uslernfoerderung4 = /** @type {(inputs: _Field_Uslernfoerderung4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US-Schüler:innen pro Lerförderung`)
};

/**

* @param {_Field_Uslernfoerderung4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_uslernfoerderung4 = /** @type {((inputs?: _Field_Uslernfoerderung4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Uslernfoerderung4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_uslernfoerderung4(inputs)
});
export { _field_uslernfoerderung4 as "_field_USLernFoerderung" }